import { Component, Input } from '@angular/core';
import { CartService } from 'src/app/services/cart.service';
import { DrawerService } from 'src/app/components/drawer.service';

@Component({
  selector: 'app-basket',
  templateUrl: './basket.component.html',
  styleUrls: ['./basket.component.css']
})
export class BasketComponent {

  @Input() basket;
  @Input() basketHeight;
  updatedBaskets: any = [];

  constructor(private cartService: CartService, private drawerService: DrawerService) { }

  onAddToCart(ID, Name, Price, Picture, Ingredients) {

    const data = {
      _id: ID,
      name: Name,
      price: Price,
      picture: Picture,
      products: Ingredients,
      quantity: 1
    }

    this.cartService.addToCart(data);
    this.drawerService.setDrawerState(true);
  }
}
